/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
import 'resources/less/themes/base/widgets/popup.less';
import 'APP_THEME/_common/login_popup/index.less';

import router from 'assets/js/common/router/index';
import Popup from 'assets/js/modules/popup/PopupLight';
import 'jquery.cookie';

var AuthPopup = function(options) {
    var self = this;

    options = options || {};
    this.reload = options.reload || false;
    this.templateOptions = options.templateOptions || {};
    this.onCompleteCallback = options.onComplete || null;
    this.onCancelCallback = options.onCancel || null;
    this.inProgress = false;
    this.$el = $('.login-popup');
    if (!this.$el.length) {
        this.$el = $('<div class="login-popup">');
    }

    this.popup = new Popup(this.$el, {
        width: 500,
        closeText: 'close-login',
        close: function() {
            self.clearTemplateOptions();
            $.cookie('stayGuest', true, { secure: true });
        }
    });
    self.initLoginHandling();
};

AuthPopup.prototype = {
    /**
     * @returns {Deferred}
     */
    showLoginFormAction: function() {
        var self = this;
        this.setTemplateOptions();

        return $.ajax({
            url: router.generate('/login'),
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            success: function(data) {
                self.popup.setContent(data.form);
                self.initSocialLogin();
                self.popup.open();
            },
            error: this.fallback,
            complete: function() {
                self.inProgress = false;
            },
            beforeSend: function() {
                if (self.inProgress === true) {
                    return;
                }
                self.inProgress = true;
            }
        });
    },

    initSocialLogin: function() {
        var _this = this;
        var isSocialLoginEnabled = this.popup.find('.myonp-login').data('social-login');
        if (isSocialLoginEnabled === true) {
            // if facebook fails to load, banner slider still works
            require(['assets/js/modules/api/facebook'], function(facebook) {
                facebook.loadSdk().done(function() {
                    var $fbButton = _this.popup.find('#facebook-login-button');
                    $fbButton.css('display', 'inline-block');
                    $fbButton.on('click', function() {
                        facebook.login(true);
                    });
                });
            });
        }
    },

    onLoginComplete: function(data) {
        if (this.onCompleteCallback) {
            this.onCompleteCallback(data);
        }

        if (this.reload) {
            //handle with refreshing a page loaded with POST method
            window.location.href = window.location.href;
            return;
        }

        if (data.loginBlock) {
            this.updateHeader(data.loginBlock);
        }

        if (data.user) {
            this.updateONP(data.user);
        }

        this.popup.close();
    },

    updateONP: function(loggedUser) {
        ONP.user.loggedIn = true;
    },

    updateHeader: function(loginBlock) {
        $('.account').html(loginBlock);
    },

    setTemplateOptions: function() {
        for (var optionName in this.templateOptions) {
            if (this.templateOptions.hasOwnProperty(optionName)) {
                var key = 'loginPopup_' + optionName;
                $.cookie(key, this.templateOptions[optionName], { path: '/', secure: true });
            }
        }
    },

    clearTemplateOptions: function() {
        for (var optionName in this.templateOptions) {
            if (this.templateOptions.hasOwnProperty(optionName)) {
                var key = 'loginPopup_' + optionName;
                $.removeCookie(key, { path: '/', secure: true });
            }
        }
    },

    setOnComplete: function(callback) {
        this.onCompleteCallback = callback;
    },

    setOnCancel: function(callback) {
        this.onCancelCallback = callback;
    },

    fallback: function() {
        window.location = router.generate('/login');
    },

    initLoginHandling: function() {
        var self = this;

        this.$el.on('submit', 'form', function(e) {
            if ($(this).hasClass('fos_user_resetting_request') || $(this).hasClass('js-transfer-form')) {
                return;
            }
            var _this = self;

            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: $(this).attr('action'),
                data: $(this).serialize(),
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                success: function(data) {
                    if (data.form) {
                        self.popup.setContent(data.form);
                        self.initSocialLogin();
                        return;
                    }

                    _this.onLoginComplete(data);
                }
            });
        });

        this.$el.on('submit', 'form.js-transfer-form', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: $(this).attr('action'),
                data: $(this).serialize(),
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                success: function(data) {
                    self.popup.setContent(data);
                }
            });
        });

        this.$el.on('click', '.embedded-content-link', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: $(this).attr('href'),
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                data: $(this).serialize(),
                success: function(data) {
                    self.popup.setContent(data);
                },
                error: function() {
                    window.location = $(this).attr('href');
                }
            });
        });

        this.$el.on('click', '.close-login-popup, .cancel, .js-cancel', function(e) {
            e.preventDefault();
            self.popup.close();
        });
    }
};

export default AuthPopup;
